
/* ============= Custom Tab =============  */
/* イベント委譲: DOMContentLoaded 後に追加・再描画された .c-tab も動作する */
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.c-tab');
  if (!tab) return;
  var ancestorEle = tab.closest('.c-tab-panel');
  if (!ancestorEle) return;

  var activeEls = ancestorEle.getElementsByClassName('is-active');
  if (activeEls.length) activeEls[0].classList.remove('is-active');
  tab.classList.add('is-active');

  var showEls = ancestorEle.getElementsByClassName('is-show');
  if (showEls.length) showEls[0].classList.remove('is-show');

  var groupTabs = ancestorEle.getElementsByClassName('c-tab');
  var arrayTabs = Array.prototype.slice.call(groupTabs);
  var index = arrayTabs.indexOf(tab);
  var panels = ancestorEle.getElementsByClassName('c-panel');
  if (index >= 0 && panels[index]) {
    panels[index].classList.add('is-show');
  }
});